import { useCallback, useState } from "react";
import { socialWallApiService } from "./services/api";
import {
  SocialWallAccount,
  SocialWallPost,
  SocialWallProvider,
} from "./interfaces";

export function useSocialWallCore() {
  const [accounts, setAccounts] = useState<SocialWallAccount[]>([]);
  const [loadingAccounts, setLoadingAccounts] = useState(false);

  const loadAccounts = useCallback(async (companyId: string) => {
    setLoadingAccounts(true);
    try {
      const list = await socialWallApiService.getAccounts(companyId);
      setAccounts(list);
      return list;
    } finally {
      setLoadingAccounts(false);
    }
  }, []);

  const loadFeed = useCallback(
    async (
      companyId: string,
      provider: SocialWallProvider | string,
      opts?: { limit?: number; q?: string; mediaType?: string }
    ): Promise<SocialWallPost[]> => {
      const payload = await socialWallApiService.getFeed(companyId, {
        provider,
        limit: opts?.limit ?? 25,
        q: opts?.q,
        mediaType: opts?.mediaType,
      });
      return payload.posts || [];
    },
    []
  );

  return {
    accounts,
    loadingAccounts,
    loadAccounts,
    loadFeed,
  };
}
